<template>
  <div>
    <el-image-viewer v-if="showViewer" :on-close="onClose" :url-list="urlList" :z-index="9999" />
  </div>
</template>
<script>
import elImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: { elImageViewer },
  data() {
    return {
      hrefUrl: "",
      showViewer: false,
      urlList: []
    };
  },
  mounted() {
    this.hrefUrl = `/download?sessionId=${this.pltSession.getSession()}&id=`;
  },
  methods: {
    openView(imgUrlListOrId, isNotedId = false) {
      this.showViewer = true;
      if (isNotedId) {
        this.getFileData(imgUrlListOrId);
      } else {
        imgUrlListOrId.forEach(({ id }) => {
          let tmp = `${this.hrefUrl}${id}&disposition=inline`;
          this.urlList.push(tmp);
        });
      }
    },
    onClose() {
      this.showViewer = false;
      this.urlList = [];
    },
    getFileData(id) {
      let url = "http://MID-TECH-IMAGE/messageService/documentService/queryDocument";
      this.invoke(url, { id }).then((res) => {
        res.files.forEach(({ id }) => {
          let tmp = `${this.hrefUrl}${id}&disposition=inline`;
          this.urlList.push(tmp);
        });
      });
    }
  }
};
</script>